import { render } from "./DashboardAlertsServices.vue?vue&type=template&id=1ebeb463"
import script from "./DashboardAlertsServices.vue?vue&type=script&lang=js"
export * from "./DashboardAlertsServices.vue?vue&type=script&lang=js"

import exportComponent from "/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__